import * as THREE from 'three';
import SceneSubject from './SceneSubject';
import GeneralLights from './GeneralLights';
import { Easing, Tween, autoPlay } from 'es6-tween'

export default canvas => {
    var ani ;
    const clock = new THREE.Clock();
    const origin = new THREE.Vector3(50,-50,0);

    const screenDimensions = {
        width: canvas.width,
        height: canvas.height
    }

    const mousePosition = {
        x: 0,
        y: 0
    }

    const scene = buildScene();
    const renderer = buildRender(screenDimensions);
    const camera = buildCamera(screenDimensions);
    const sceneSubjects = createSceneSubjects(scene);
    const parentDOM = document.getElementById('ele');


    var audioListener = new THREE.AudioListener();
    camera.add( audioListener );
    var oceanAmbientSound = new THREE.Audio( audioListener );

    // add the audio object to the scene
    scene.add( oceanAmbientSound );

    // instantiate a loader
    var loader = new THREE.AudioLoader();
    loader.load(
        // resource URL
        './assets/audio/project.ogg',

        // onLoad callback
        function ( audioBuffer ) {
            //alert('c');
            // set the audio object buffer to the loaded object
            oceanAmbientSound.setBuffer( audioBuffer );

            // play the audio
            //oceanAmbientSound.play();
        },

        // onProgress callback
        function ( xhr ) {
            console.log( (xhr.loaded / xhr.total * 100) + '% loaded' );
        },

        // onError callback
        function ( err ) {
            console.log( 'An error happened' );
        }
    );

/*
    function animating(ref){
        alert(ref);
    }
    */
    function buildScene() {
        const scene = new THREE.Scene();
        scene.background = new THREE.Color("#444");
        return scene;
    }

    function buildRender({ width, height }) {
        const renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true }); 
        const DPR = window.devicePixelRatio ? window.devicePixelRatio : 1;
        renderer.setPixelRatio(DPR);
        renderer.setSize(width, height);

        renderer.gammaInput = true;
        renderer.gammaOutput = true; 

        return renderer;
    }

    function buildCamera({ width, height }) {
        const aspectRatio = width / height;
        const fieldOfView = 28;
        const nearPlane = 4;
        const farPlane = 10000; 
        const camera = new THREE.PerspectiveCamera(fieldOfView, aspectRatio, nearPlane, farPlane);

        camera.position.x = 0;
        camera.position.y = 50;
        camera.position.z = 0;
        return camera;
    }

    function createSceneSubjects(scene) {
        const sceneSubjects = [
            new GeneralLights(scene),
            new SceneSubject(scene)
        ];

        return sceneSubjects;
    }


    function update() {
        autoPlay(true);

        const elapsedTime = clock.getElapsedTime();

        for(let i=0; i<sceneSubjects.length; i++)
            sceneSubjects[i].update(elapsedTime);

        updateCameraPositionRelativeToMouse();
        renderer.render(scene, camera);
        switchanimate(parentDOM.getAttribute('animatestate'),camera);

    }

    function switchanimate(anicheck,camera){
        if(anicheck==1){
            //setTimeout(50,()=>{
                parentDOM.setAttribute('animatestate',0);
                switch(parentDOM.getAttribute('menuactive')){
                    
                    case 'about':
                        new Tween(camera.position)
                          .to({
                            'x':0,
                            'y':50,
                            'z':0
                            },
                            1000
                          )
                          .start();
                        new Tween(origin)
                          .to({
                            'x':50,
                            'y':-50,
                            'z':0
                            },
                            1000
                          )
                          .start();
                        break;
                        
                    case 'service':
                        new Tween(camera.position)
                          .to({
                            'x':0,
                            'y':0,
                            'z':0
                            },
                            1000
                          )
                          .start();
                        new Tween(origin)
                          .to({
                            'x':50,
                            'y':-50,
                            'z':50
                            },
                            1000
                          )
                          .start();
                          break;
                    case 'gallery':
                        new Tween(camera.position)
                          .to({
                            'x':0,
                            'y':0,
                            'z':50
                            },
                            1000
                          )
                          .start();
                        new Tween(origin)
                          .to({
                            'x':0,
                            'y':0,
                            'z':0
                            },
                            1000
                          )
                          .start();
                          break;                    
                    case 'lab':
                         new Tween(camera.position)
                          .to({
                            'x':0,
                            'y':0,
                            'z':0
                            },
                            1000
                          )
                          .start();
                        new Tween(origin)
                          .to({
                            'x':-50,
                            'y':-50,
                            'z':50
                            },
                            1000
                          )
                          .start();
                          break;                 
                    case 'contact':
                        new Tween(camera.position)
                          .to({
                            'x':0,
                            'y':100,
                            'z':250
                            },
                            1000
                          )
                          .start();
                        new Tween(origin)
                          .to({
                            'x':0,
                            'y':0,
                            'z':0
                            },
                            1000
                          )
                          .start();
                          break;
                }
        }
    }
    function updateCameraPositionRelativeToMouse() {
        camera.position.x += (  (mousePosition.x * 0.015) - camera.position.x ) * 0.05;
        camera.position.y += ( -(mousePosition.y * 0.015) - camera.position.y ) * 0.05;
        camera.lookAt(origin);
    }

    function onWindowResize() {
        const { width, height } = canvas;
        
        screenDimensions.width = width;
        screenDimensions.height = height;

        camera.aspect = width / height;
        camera.updateProjectionMatrix();
        
        renderer.setSize(width, height);
    }

    function onMouseMove(x, y) {
        mousePosition.x = x;
        mousePosition.y = y;
    }

    return {
        update,
        onWindowResize,
        onMouseMove
    }
}


// WEBPACK FOOTER //
// ./src/header/threejs/SceneManager.js